<template>
<v-container grid-list-sm>
        <v-layout row wrap>
            <v-flex xs12>
                <v-container grid-list-sm class="pt-0">
                    <v-layout row wrap>
                        <v-flex xs7>
                            <v-layout align-center justify-start row fill-height>
                                <h1 class="title font-weight-light">Staff List ({{ $format.int(pager.totalRecords) }})</h1>
                                <v-tooltip right>
                                    <template>
                                        <v-btn slot="activator" flat icon color="accent" class="mt-2" @click="onItemAdd"><v-icon>add_circle</v-icon></v-btn>
                                    </template>
                                    <span>Add a new user/staff member</span>
                                </v-tooltip>
                            </v-layout>
                        </v-flex>
                        <v-flex xs5>
                            <v-layout align-center justify-end row fill-height>
                                <v-tooltip left>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon v-on="on" @click="toggleSearchAt">
                                            <v-icon>{{ searchAt.icon }}</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Match search text at this position</span>
                                </v-tooltip>
                                <v-text-field ref="search" v-model="searchText" placeholder="Type here to filter the list" :hint="`(${searchAt.text}) Name, Username, Opera Name, Email, EA`" persistent-hint prepend-icon="search" clearable @keyup.native="searchChange" @click:clear="searchChange"></v-text-field>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12>
                            <v-card>
                                <v-data-table :headers="headers" :items="tableData" :loading="isBusy" hide-actions>
                                    <template slot="items" slot-scope="props">
                                        <tr>
                                            <td>
                                                <div>{{ `${props.item.FN} ${props.item.LN}`.trim() }}</div>
                                                <div class="f-m opa-6">{{ props.item.Win }}</div>
                                            </td>
                                            <td>
                                                <div>{{ props.item.UN }}</div>
                                                <div class="f-m opa-6">{{ props.item.ON }}</div>
                                            </td>
                                            <td>
                                                <div>{{ props.item.EA }}</div>
                                                <div class="f-m opa-6">{{ props.item.IsA ? 'Active' : 'Locked' }}</div>
                                            </td>
                                            <td>
                                                <div>{{ props.item.R }}</div>
                                                <div class="f-m opa-6">{{ $format.dateTime(props.item.LastDt) }}</div>
                                            </td>
                                            <td>
                                                <div>{{ props.item.E }}</div>
                                                <div class="f-m opa-6">{{ props.item.M }}</div>
                                            </td>
                                            <!-- <td>{{ props.item.Win }}</td>
                                            <td>{{ props.item.ON }}</td>
                                            <td>{{ props.item.EA }}</td> -->
                                            <!-- <td>{{ getPermissionNames(props.item) }}</td> -->
                                            <td class="justify-center layout px-0">
                                                <v-icon small class="mr-2" @click="onItemEdit(props.index, props.item)">edit</v-icon>
                                                <v-icon small @click="onItemDelete(props.index, props.item)">delete</v-icon>
                                            </td>
                                        </tr>
                                    </template>
                                    <template slot="no-data">
                                        <v-subheader>No data.</v-subheader>
                                    </template>
                                </v-data-table>
                                <v-divider></v-divider>
                                <div class="el-clearfix">
                                    <div class="pt-2 pb-1 el-float-left">
                                        <v-pagination v-model="pager.currentPage" :length="pager.pages" :total-visible="5" @next="loadData" @previous="loadData" @input="loadData"></v-pagination>
                                    </div>
                                    <div class="pb-1 pl-2 el-float-right">
                                        <v-select v-model="pager.pageSize" :items="pageSizes" label="Page Size" dense hide-details style="max-width:80px;" @change="loadData"></v-select>
                                    </div>
                                </div>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
        </v-layout>
        <v-dialog v-model="showDialog" persistent max-width="600">
            <v-card>
                <v-card-title class="headline">User Detail</v-card-title>
                <v-card-text>
                    <v-container grid-list-sm class="pa-0">
                        <v-layout row wrap>
                            <v-flex xs6 pr-3>
                                <v-text-field ref="name" label="First Name" v-model="item.FN" required :rules="requiredRules" :counter="30" :disabled="isEditing"></v-text-field>
                            </v-flex>
                            <v-flex xs6 pl-3>
                                <v-text-field label="Last Name" v-model="item.LN" required :rules="requiredRules" :counter="30" :disabled="isEditing"></v-text-field>
                            </v-flex>
                            <v-flex xs6 pr-3>
                                <v-text-field label="Username" v-model="item.UN" required :rules="requiredRules" :counter="30" :disabled="isEditing"></v-text-field>
                            </v-flex>
                            <v-flex xs6 pl-3>
                                <v-select v-model="item.R_Id" :items="roleList" label="Role" item-text="Name" item-value="_id" :loading="isLookupBusy" :disabled="isEditing"></v-select>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field label="Email Address" v-model="item.E" required :rules="emailRules" :counter="60" :disabled="isEditing" type="email"></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-btn-toggle v-model="selectedTab" mandatory>
                                    <v-btn flat value="more">More</v-btn>
                                    <v-btn flat value="logins">Logins</v-btn>
                                </v-btn-toggle>
                            </v-flex>
                            <v-flex xs12><v-divider></v-divider></v-flex>
                            <v-flex xs6 pr-3 v-show="selectedTab==='more'">
                                <v-text-field label="Mobile" v-model="item.M" :disabled="isEditing"></v-text-field>
                            </v-flex>
                            <v-flex xs6 pl-3 v-show="selectedTab==='more'">
                                <v-text-field label="EA Code" v-model="item.EA" :disabled="isEditing"></v-text-field>
                            </v-flex>
                            <v-flex xs6 pr-3 v-show="selectedTab==='more'">
                                <v-select v-model="item.D_Id" :items="departmentList" label="Department" item-text="Name" item-value="_id" :loading="isLookupBusy" :disabled="isEditing"></v-select>
                            </v-flex>
                            <v-flex xs6 pl-3 v-show="selectedTab==='more'">
                                <v-select v-model="item.UT_Id" :items="userTypeList" label="User Type" item-text="Name" item-value="_id" :loading="isLookupBusy" :disabled="isEditing"></v-select>
                            </v-flex>
                            <v-flex xs12 v-show="selectedTab==='logins'">
                                <v-text-field label="Windows User Login" v-model="item.Win" :disabled="isEditing"></v-text-field>
                            </v-flex>
                            <v-flex xs12 v-show="selectedTab==='logins'">
                                <v-text-field label="Opera User" v-model="item.ON" :disabled="isEditing"></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="onNewPassword" :loading="isPasswordBusy" v-show="showPassword">New Password</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="showDialog = false">Cancel</v-btn>
                    <v-btn color="primary" :loading="isDialogBusy" @click="onDialogSave" :disabled="formIsValid">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="isDialogBusy" persistent width="300">
            <v-card color="primary" dark>
                <v-card-text>
                    Processing...
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
// import { required } from 'vuelidate/lib/validators';
import Constants from '../../util/Constants';

export default {
    name: 'Staff',
    props: {},
    data() {
        return {
            title: 'Staff Administration',
            user: { has: () => 0 },
            ViewCompany: {},
            searchText: '',
            searchOptions: Constants.SEARCH_OPTIONS,
            searchAt: {},
            searchAtOptions: Constants.SEARCH_AT_OPTIONS,
            selected: null,
            item: {
                _id: '',
                FN: '',
                LN: '',
                UN: '',
                // Pwd: '',
                // TODO: Job title e.g. Manager, Staff, Analyst, Engineer, Tester, Temp, etc.
                // TODO: Location and Office
                ID: '',
                Win: '',
                ON: '',
                EA: '',
                E: '',
                M: '',
                C: [],
                // LastDt: null,
            },
            selectedTab: 'more',
            headers: [
                { text: 'Name', value: 'FN', align: 'left' },
                { text: 'Username', value: 'UN', align: 'left', width: '100px' },
                { text: 'EA', value: 'EA', align: 'left', width: '100px' },
                { text: 'Role', value: 'R', align: 'left' },
                { text: 'Email', value: 'E', align: 'left' },
                // { text: 'Windows User', value: 'Win', align: 'left' },
                // { text: 'Opera Name', value: 'ON', align: 'left' },
                // { text: 'EA Code', value: 'EA', align: 'left' },
                { text: 'Action', value: 'Name', align: 'right', width: '110px', sortable: false },
            ],
            pager: {
                pageSize: 10,
                currentPage: 1,
                pages: 1,
                totalRecords: 0
            },
            pageSizes: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 60, 70, 80, 90, 100],
            isBusy: false,
            isLookupBusy: false,
            showDialog: false,
            isEditing: false,
            isDialogBusy: false,
            tableData: [],
            roleList: [],
            departmentList: [],
            userTypeList: [],
            requiredRules: [
                v => !!v || 'Field is required',
                v => (v && v.length <= 30) || 'This field must be less than 30 characters'
            ],
            emailRules: [
                v => !!v || 'Email is required',
                v => (v && v.length <= 60) || 'Email must be less than 60 characters',
                v => /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/.test(v) || 'E-mail must be valid'
            ],
            showPassword: false,
            isPasswordBusy: false,
        };
    },
    mounted() {
        this.$root.$on('CompanySwitched', () => {
            this.ViewCompany = this.$ls.get('ViewCompany', {});
            this.searchText = '';
            this.loadData();
        });

        this.user = this.$ls.get('User');
        Object.defineProperty(this.user, 'has', { value: this.$has });
        this.ViewCompany = this.$ls.get('ViewCompany', {});
        this.pager.pageSize = this.$ls.get('PageSize_Staff', 10);
        this.searchAt = this.searchAtOptions[0];
        this.loadLookups();
        this.loadData();
        setTimeout(() => this.$refs.search.focus(), 250);
    },
    computed: {
        formIsValid() {
            return (
                !this.item.FN ||
                !this.item.LN ||
                !this.item.UN ||
                !this.item.E);
        }
    },
    methods: {
        setFocus() {
            setTimeout(() => this.$refs.name.focus(), 250);
        },
        reset() {
            // this.$v.$reset();
        },
        async loadLookups() {
            try {
                this.isLookupBusy = true;
                const deps = await this.$http.post('/Department/list', { C_Id: this.ViewCompany._id, _page: { per: 100, page: 1 } });
                this.departmentList = deps.data.d;
                const roles = await this.$http.post('/Role/list', { C_Id: this.ViewCompany._id, _page: { per: 100, page: 1 } });
                this.roleList = roles.data.d;
                const userTypes = await this.$http.get('/UserType', { C_Id: this.ViewCompany._id });
                this.userTypeList = userTypes.data.d;
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Data Error', message: 'An error occurred fetching the data.' });
            }
            finally {
                this.isLookupBusy = false;
            }
        },
        async loadData() {
            try {
                this.isBusy = true;
                this.searchText = this.searchText || '';
                const response = await this.$http.post('/User/list', { search: this.searchText.trim(), searchAt: this.searchAt.value, C_Id: this.ViewCompany._id, _page: { per: this.pager.pageSize, page: this.pager.currentPage } });
                this.rawData = response.data.d;
                this.pager.totalRecords = response.data.p.t;
                this.pager.pages = response.data.p.pt;
                this.tableData = response.data.d;
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Data Error', message: 'An error occurred fetching the data.' });
            }
            finally {
                this.isBusy = false;
            }
        },
        toggleSearchAt() {
            let pos = this.searchAtOptions.indexOf(this.searchAt);
            pos += 1;
            if (pos === this.searchAtOptions.length) pos = 0;
            this.searchAt = this.searchAtOptions[pos];
            if (this.searchText.trim().length) this.loadData();
            this.$refs.search.focus();
        },
        searchChange() {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => {
                this.pager.currentPage = 1;
                this.loadData();
            }, 600);
        },
        onItemAdd() {
            this.reset();
            this.selected = null;
            this.item = {};
            this.item.C_Id = this.ViewCompany._id;
            this.item.IsA = true;
            /* this.item.FN = this.searchText || '';
            this.item.LN = '';
            this.item.UN = '';
            this.item.ID = '';
            this.item.Win = '';
            this.item.ON = '';
            this.item.EA = '';
            this.item.E = '';
            this.item.M = ''; */
            this.item.C = [{ _id: this.ViewCompany._id }];
            // this.isEditing = false;
            this.showPassword = false;
            this.showDialog = true;
            this.setFocus();
        },
        onItemEdit(idx, rec) {
            this.reset();
            this.selected = rec;
            this.item = rec;
            /* this.item._id = rec._id;
            this.item.FN = rec.FN;
            this.item.LN = rec.LN;
            this.item.UN = rec.UN;
            this.item.ID = rec.ID;
            this.item.Win = rec.Win;
            this.item.ON = rec.ON;
            this.item.EA = rec.EA;
            this.item.E = rec.E;
            this.item.M = rec.M;
            this.item.C = rec.C; */
            // this.isEditing = true;
            const sett = this.item.C.find(o => o._id === this.ViewCompany._id);
            this.item.R_Id = sett.R_Id;
            this.item.D_Id = sett.D_Id;
            this.item.UT_Id = sett.UT_Id;
            this.showPassword = true;
            this.showDialog = true;
            this.setFocus();
        },
        onItemDelete(idx, rec) {
            this.$confirm({
                title: 'Delete?',
                message: 'This will delete the user. Are you sure you want to continue?'
            }, value => {
                if (value) {
                    this.isDialogBusy = true;
                    this.$http.post('/User/save', { _id: rec._id, _x: true })
                        .then(response => {
                            if (!response.data.s) this.$alert({ type: 'error', title: 'Delete Failed', message: 'An error has occurred. Please contact your systems administrator.' });
                            this.loadData();
                        })
                        .catch(err => {
                            console.error(err);
                            this.$alert({ type: 'error', title: 'Delete Error', message: `An error occurred trying to delete the data. ${err.message}` });
                        })
                        .finally(() => {
                            this.isDialogBusy = true;
                        });
                }
            });
        },
        async onDialogSave() {
            this.isDialogBusy = true;
            try {
                if (!this.selected) {
                    this.item._id = null;
                }
                // Some settings are company specific and need to be added to C.
                let sett = this.item.C.find(o => o._id === this.ViewCompany._id);
                if (!sett) {
                    sett = { _id: this.ViewCompany._id };
                    this.item.C.push(sett);
                }
                sett.R_Id = this.item.R_Id;
                sett.D_Id = this.item.D_Id;
                sett.UT_Id = this.item.UT_Id;
                delete this.item.R_Id;
                delete this.item.D_Id;
                delete this.item.UT_Id;

                const response = await this.$http.post('/User/save', this.item);
                if (!response.data.s) this.$alert({ type: 'error', title: 'Save Failed', message: 'An error has occurred. Please contact your systems administrator.' });
                this.loadData();
                this.showDialog = false;
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Save Error', message: `An error occurred trying to save the data. ${err.message}` });
            }
            this.isDialogBusy = false;
        },
        onNewPassword() {
            this.$prompt({ title: 'New Password', message: 'Enter the new password:', value: '' }, result => {
                if (result.Action) {
                    if (`${result.Value}`.trim() === '') return;
                    this.setPassword(result.Value);
                }
            });
        },
        async setPassword(passw) {
            this.isPasswordBusy = true;
            try {
                await this.$http.post('/User/password', { C_Id: this.ViewCompany._id, U_Id: this.item._id, P: passw });
                this.$alert({ title: 'Password Updated', message: 'The new password has been set.' });
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Password Error', message: `An error occurred trying to udate the password. ${err.message}` });
            }
            this.isPasswordBusy = false;
        },
        copyOne() {
            this.$alert({ type: 'info', title: 'Coming soon ...', message: 'This feature will be implemented soon.' });
        },
        copyAll() {
            this.$alert({ type: 'info', title: 'Coming soon ...', message: 'This feature will be implemented soon.' });
        }
    }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Company/Staff.vue